module.exports = __webpack_public_path__ + "img/link07_sp.40f10094.png";